// A ShortCode is a combination of a subscription code and a currency paired together.
// e.g. personal-v2-gbp-medium
// Code: personal-v2-medium, Currency: GBP

import { Currency, currencyCodes, isBusinessPlan } from '../locale';
import { nonNullable } from '../utils';
import { isCawAddon, isCawPlan } from './climate-action-workforce';

export const isWorkforceSubscription = (planId: string) => isBusinessPlan(planId) || isCawPlan(planId);

/**
 * Converts shortCodes into new format
 * business-v1-gbp-medium --> business-v1-medium w. cc: GBP
 *
 */
export const fromShortCode = (shortCode: string): { code: string; currency: Currency } => {
  const pieces = shortCode.split('-');
  const currency = pieces.find(piece => (currencyCodes as readonly string[]).includes(piece.toUpperCase()));

  if (currency)
    pieces.splice(
      pieces.findIndex(p => p == currency),
      1,
    );

  return {
    code: pieces.join('-'),
    currency: currency ? (currency.toUpperCase() as Currency) : 'GBP',
  };
};

/**
 * Backwards compatability with old id format
 */
export const toShortCode = (code: string, currency: Currency): string => {
  const segments = code.split('-');

  const versionIdx = segments.findIndex(segment => ['v1', 'v2'].includes(segment));
  const version = versionIdx != -1 ? segments.splice(versionIdx, 1)[0] : undefined;

  const sizeIdx = segments.findIndex(segment => ['small', 'medium', 'large'].includes(segment));
  const size = sizeIdx != -1 ? segments.splice(sizeIdx, 1)[0] : undefined;

  // V1, GBP or reforestation projects don't include currency in their codes
  const currencyCode = (version == 'v1' && currency == 'GBP') || code.includes('reforestation') ? undefined : currency;

  // string - version - currency - size
  return [...segments, version, currencyCode, size].filter(nonNullable).join('-').toLowerCase();
};

export const isLegacySubscriptionPlan = (planShortCode: string) => {
  return !isCawPlan(planShortCode);
};

export const isLegacySubscriptionAddon = (addonShortCode: string) => {
  return !isCawAddon(addonShortCode);
};
